export const COLORS = {
    lightBlue: '#48befa',
    darkBlue: '#3a9dc8',
    
    lightGrey: '#dfdfdf',
    darkGrey: '#828282',
    
    black: '#000000',
    white: '#ffffff',
    
    // Add the specific blue color you mentioned
    menuBlue: '#29aef8'
};